import { WhiteModal } from 'components/Modal';
import StatusTable from 'components/StatusTable';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface StatusDefinitionsModalProps {
  open: boolean;
  onClose: () => void;
}

export default function StatusDefinitionsModal({
  open,
  onClose,
}: StatusDefinitionsModalProps) {
  const { t } = useTranslation();

  return (
    <WhiteModal
      open={open}
      onCancel={onClose}
      title={t('glossaire:modal_title_statuts_definition')}
      closable={true}
      footer={null}
    >
      <StatusTable />
    </WhiteModal>
  );
}
